import { render, staticRenderFns } from "./bonusManagement.vue?vue&type=template&id=c1452c14"
import script from "./bonusManagement.vue?vue&type=script&lang=js"
export * from "./bonusManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports